import "./scss/archive_2022.scss";

// npmから直でinstallできないのでやり方が特殊になっている
const cheet = require("../../../namuol-cheet.js/cheet.js");
const baron = require('baron');
import GLightbox from 'glightbox';

const { update_inner_css_values } = require('./js/ushiya/inner_css_values');
const { scrollout_init } = require('./js/ushiya/scrollout_init/');
const { define_svg_element,emit_on_all_svg_loaded,emit_on_all_svg_full_loaded,define_footer_element } = require('./js/ushiya/custom_element');


let baron_instance;
export let ScrollOut = require("./js/ushiya/scroll_out/");

//const { add_navigation_SVG_ready_handler } = require('./navgation_common.js');
const { add_loading_screen_SVG_ready_handler } = require('./loading_screen_common.js');

define_svg_element();
define_footer_element();

const scrollout_custom_handler = (e,so,hidden) =>{
    // e... ビューポートに出現した要素(DOMオブジェクト)
    // so... ScrollOutオブジェクトインスタンス
    // hidden... 要素がビューポート外に出た場合はtrue、それ以外はfalse
    if(hidden){
        if(e.matches('section.top-most-section')){
            let DOM_navigation_svg=document.querySelector('#navigation01');
        
            if(DOM_navigation_svg){

                DOM_navigation_svg.classList.add('away-from-top');
            }
        }
        if(e.matches('#section_archive_2022_chairperson_container #content-area')){
            let DOM_svg=e.closest('svg');
            DOM_svg.classList.remove('text_appear');
        }

    } else {
        if(e.matches('section.top-most-section')){
            let DOM_navigation_svg=document.querySelector('#navigation01');
        
            if(DOM_navigation_svg){

                DOM_navigation_svg.classList.remove('away-from-top');
            }
        }
        
        if(e.matches('#section_archive_2022_chairperson_container #content-area')){
            let DOM_svg=e.closest('svg');
            console.log("text_appear");
            DOM_svg.classList.add('text_appear');
        }
        if(e.matches('#area_section_archive_2022_semifinalist_01')){
            let DOM_svg=e.closest('svg');
            DOM_svg.classList.add('semifinalist_01_appear');
        }
        if(e.matches('#area_section_archive_2022_semifinalist_02')){
            let DOM_svg=e.closest('svg');
            DOM_svg.classList.add('semifinalist_02_appear');
        }
        if(e.matches('#area_section_archive_2022_semifinalist_03')){
            let DOM_svg=e.closest('svg');
            DOM_svg.classList.add('semifinalist_03_appear');
        }
        if(e.matches('#area_section_archive_2022_semifinalist_04')){
            let DOM_svg=e.closest('svg');
            DOM_svg.classList.add('semifinalist_04_appear');
        }
        if(e.matches('#area_section_archive_2022_semifinalist_prize')){
            let DOM_svg=e.closest('svg');
            DOM_svg.classList.add('semifinalist_prize_appear');
        }


    }
}

window.addEventListener('DOMContentLoaded',async (event)=>{

    baron_instance = baron({
        root: '.baron',
        scroller: '.baron__scroller',
        bar: '.baron__bar'
    });

    window.baron_instance  = baron_instance;
    
    //update_inner_css_valuesの呼び出し方に注意
    //これはハンドラを返す関数なので関数名ではなく関数呼び出しでないとダメ。
    window.addEventListener('resize',update_inner_css_values());

});

window.addEventListener('all_svg_ready',
    (e)=>{
        let now = new Date();
        console.log(`all_svg_ready at: ${now.toLocaleString()}:${now.getMilliseconds()}`);
        scrollout_init({
            special_scrollin:scrollout_custom_handler
        });
    }
);


window.addEventListener('DOMContentLoaded',
    ()=>{
        add_loading_screen_SVG_ready_handler({fade_on:'all_svg_ready'});
        emit_on_all_svg_full_loaded(
            [
                'extern-svg#section_archive_2022_chairperson_container',
                'extern-svg#section_archive_2022_semifinalist_container',
            ]    
            );
    
        //add_navigation_SVG_ready_handler();

        document.querySelector('extern-svg#floats_container').addEventListener('svgready',
                (e)=>{
                    let DOM_svg=e.target.querySelector(':scope svg');

                    DOM_svg.addEventListener('return_to_mainpage_click',()=>{
                        // FIXME:ここにディレイが必要
                        const url="https://impa.jp/concorso/";
                        //console.log(`location: ${url}`);
                        window.location.href=url;
                    });
                }
        );


        document.querySelector('extern-svg#section_archive_2022_chairperson_container').addEventListener('svgready',
                (e)=>{
                    let DOM_svg=e.target.querySelector(':scope svg');

                    DOM_svg.addEventListener('section_archive_2022_chairperson_play_message_button_click',()=>{
                        // FIXME:ここにディレイが必要
                        // FIXME:ここにディレイが必要
                        const myGallery = GLightbox({
                            elements: [
                                {
                                    'href': 'https://www.youtube.com/watch?v=3w0E3jQoBk8?rel=0',
                                    'type': 'video',
                                    'source': 'youtube',
                                },
                            ]
                        });
                        myGallery.open();                    


                    });
                    DOM_svg.addEventListener('section_archive_2022_chairperson_play_message_youtube_site_button_click',()=>{
                        // FIXME:ここにディレイが必要
                        const url="https://www.youtube.com/watch?v=3w0E3jQoBk8?rel=0";
                        console.log(`location: ${url}`);
                        window.open(url, '_blank');
                    });

                }
        );

        document.querySelector('extern-svg#section_archive_2022_semifinalist_container').addEventListener('svgready',
        (e)=>{
            let DOM_svg=e.target.querySelector(':scope svg');

            DOM_svg.addEventListener('section_archive_2022_semifinalist_01_play_button_click',()=>{
                // FIXME:ここにディレイが必要
                // FIXME:ここにディレイが必要
                const myGallery = GLightbox({
                    elements: [
                        {
                            'href': 'https://www.youtube.com/embed/feoRMja6Qu0?rel=0',
                            'type': 'video',
                            'source': 'youtube',
                        },
                    ]
                });
                myGallery.open();                    


            });
            DOM_svg.addEventListener('section_archive_2022_semifinalist_01_play_youtube_button_click',()=>{
                // FIXME:ここにディレイが必要
                const url="https://www.youtube.com/embed/feoRMja6Qu0?rel=0";
                console.log(`location: ${url}`);
                window.open(url, '_blank');
            });
            /////////////////////////////////////////////////////////
            DOM_svg.addEventListener('section_archive_2022_semifinalist_02_play_button_click',()=>{
                // FIXME:ここにディレイが必要
                // FIXME:ここにディレイが必要
                const myGallery = GLightbox({
                    elements: [
                        {
                            'href': 'https://www.youtube.com/embed/g09LZ4_6ppA?rel=0',
                            'type': 'video',
                            'source': 'youtube',
                        },
                    ]
                });
                myGallery.open();                    


            });
            DOM_svg.addEventListener('section_archive_2022_semifinalist_02_play_youtube_button_click',()=>{
                // FIXME:ここにディレイが必要
                const url="https://www.youtube.com/embed/g09LZ4_6ppA?rel=0";
                console.log(`location: ${url}`);
                window.open(url, '_blank');
            });
            /////////////////////////////////////////////////////////////
            DOM_svg.addEventListener('section_archive_2022_semifinalist_03_play_button_click',()=>{
                // FIXME:ここにディレイが必要
                // FIXME:ここにディレイが必要
                const myGallery = GLightbox({
                    elements: [
                        {
                            'href': 'https://www.youtube.com/embed/mJWqE2s6hqs?rel=0',
                            'type': 'video',
                            'source': 'youtube',
                        },
                    ]
                });
                myGallery.open();                    


            });
            DOM_svg.addEventListener('section_archive_2022_semifinalist_03_play_youtube_button_click',()=>{
                // FIXME:ここにディレイが必要
                const url="https://www.youtube.com/embed/mJWqE2s6hqs?rel=0";
                console.log(`location: ${url}`);
                window.open(url, '_blank');

            });
            /////////////////////////////////////////////////////////////
            DOM_svg.addEventListener('section_archive_2022_semifinalist_04_play_button_click',()=>{
                // FIXME:ここにディレイが必要
                // FIXME:ここにディレイが必要
                const myGallery = GLightbox({
                    elements: [
                        {
                            'href': 'https://www.youtube.com/embed/H57lK4Jskmg?rel=0',
                            'type': 'video',
                            'source': 'youtube',
                        },
                    ]
                });
                myGallery.open();                    


            });
            DOM_svg.addEventListener('section_archive_2022_semifinalist_04_play_youtube_button_click',()=>{
                // FIXME:ここにディレイが必要
                const url="https://www.youtube.com/embed/H57lK4Jskmg?rel=0";
                console.log(`location: ${url}`);
                window.open(url, '_blank');

            });


        }
);


    }
);


/*
(function () {

    function removeHash(){
      history.replaceState('', document.title, window.location.origin + window.location.pathname + window.location.search);
    }
  
      window.addEventListener('boilerplatedeployed', function (event) {
          ary_DOM_link = document.querySelectorAll('a[href^="#"]');
  
          for(var DOM_link of ary_DOM_link){
              DOM_link.addEventListener('click',(e) => {
                  setTimeout(()=>{
                  // call removeHash function after set timeout
                  removeHash();
                  }, 3); // 5 millisecond timeout in this case
  
              });
          }
      });
  
  })();
*/